import { IEntityDetails, PRODUCT_KEY } from '../../types';

export const entityHasEntitledApplication = (entity: IEntityDetails, appProductKey?: PRODUCT_KEY): boolean => {
  return !!(appProductKey && entity.entitledApplications.some((app) => app.entitlementProductKey === appProductKey));
};
